import { h } from 'preact'
import entities from 'entities'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

export default ({ results }) => {
  return (
    <div className="c-blog-overview__panes u-flex">
      {results.map((item, key) => {
        return (
          <Result
            key={key}
            thumbnail={item.thumbnail}
            link={item.link}
            date={item.date}
            category={item.category[0].name}
            excerpt={item.excerpt}
            read_time={item.meta_content.time}
          >
            {item.title.rendered}
          </Result>
        )
      })}
    </div>
  )
}

const Result = ({
  children,
  thumbnail,
  category,
  excerpt,
  read_time,
  link,
  date
}) => {
  if (thumbnail === null) {
    thumbnail = `${window.theme_uri}/img/blog-background.jpg`
  }
  return (
    <a href={link} className="c-blog-item">
      <div className="c-blog-item__image">
        <div
          className="c-blog-item__background o-background"
          style={{ backgroundImage: `url(${thumbnail})` }}
        />
        {category === 'vlog' ? (
          <div className="c-blog-item__play">
            <svg className="c-play-button__icon c-icon c-blog-item__icon">
              <use xlinkHref="#play" />
            </svg>
          </div>
        ) : null}
      </div>
      <div className="c-blog-item__footer">
        <h4 className="c-blog-item__title">{entities.decodeHTML(children)}</h4>
        <span className="c-blog-item__type">
          {category === 'vlog' ? (
            <svg className="c-icon c-icon--large c-blog-item__meta-icon">
              <use xlinkHref="#video" />
            </svg>
          ) : (
            <svg className="c-icon c-icon--medium c-blog-item__meta-icon">
              <use xlinkHref="#pencil" />
            </svg>
          )}
          {category}
        </span>
        <span className="c-blog-item__date">{date}</span>
        {read_time ? (
          <span className="c-blog-item__time">{read_time} minuten</span>
        ) : null}
      </div>
    </a>
  )
}



// WEBPACK FOOTER //
// ./src/js/blog/Results.js